import { BaseForRestoreVMPlanHelper } from 'wizards/helpers/bases/base-for-restore-vm-plan-helper';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { RestorePlanFromStepsHelper } from 'wizards/helpers/restore-plan-from-steps-helper/restore-plan-from-steps-helper';

export class RestoreVMWarePlanFromStepsHelpers extends BaseForRestoreVMPlanHelper {
  protected static setSpecificStepsData(newPlan: any, settings: WizardHelpersSettings): void {
    RestorePlanFromStepsHelper.updateHost(newPlan, this.restoreVMModel.selectHostStep);
  }
}
